<template>
    <div class="wrap wrap--join">
        <!-- 헤더 -->
        <main-header></main-header>

        <!-- 메인 -->
        <main class="main" role="main">
            <div class="inner">
                <h2 class="join-title">회원가입</h2>

                <div class="join-container">
                    <div class="join-gate">
                        <!-- 개인 -->
                        <div class="join-gate-box join-gate-box--personal">
                            <h2>개인고객 가입</h2>
                            <p>
                                투명하고 합리적인 가격의 무료 인테리어 견적과 <br />
                                다양하고 푸짐한 이벤트가 준비되어 있습니다.
                            </p>
                            <a class="button button--primary" @click="submit('user')">가입하기</a>
                        </div>
                        <!-- 업체 -->
                        <div class="join-gate-box join-gate-box--business">
                            <h2>제휴업체 가입</h2>
                            <p>
                                수수료 0% 무료 홍보, 무료 중계, 국내 최고 종합 <br />
                                인테리어 새집처럼과 함께하세요.
                            </p>
                            <a class="button button--primary" @click="submit('company')">가입하기</a>
                        </div>

                        <!-- 기술자 -->
                        <div class="join-gate-box join-gate-box--business">
                            <h2>기술자 가입</h2>
                            <p>
                                기술자 설명
                            </p>
                            <a class="button button--primary" @click="submit('technician')">가입하기</a>
                        </div>
                    </div>

                    <!-- 하단버튼 -->
                    <!-- <div class="bottom-button">
                        <a class="button button--border-primary" href="" onclick="return false;" @click="$router.go(-1)"><span>취소하기</span></a>
                        <a class="button button--primary" @click="submit"><span>계속 진행</span></a>
                    </div> -->
                </div>
            </div>
        </main>

        <!-- 푸터 -->
        <main-footer></main-footer>
    </div>
</template>

<script>
import MainHeader from "@/components/client/inc/main-header.vue";
import MainFooter from "@/components/client/inc/main-footer.vue";
export default {
    components: {
        MainHeader,
        MainFooter,
    },
    methods: {
        submit(code) {
            this.$router.push(`/join?code=${code}`);
        },
    },
};
</script>
